import React from 'react';
import Heading from '@atlaskit/heading';
import { Box } from '@atlaskit/primitives';
import { LineChart as Chart } from '@atlassian/viz-platform-charts--next/charts';

export type LineChartDatum = {
	name: string;
	count: number;
};

type LineChartProps = {
	data: LineChartDatum[];
	title: string;
	singleValue?: string;
	xAxisLabel?: string;
	yAxisLabel?: string;
	children?: JSX.Element;
};

export const LineChart = ({ data, title, singleValue, xAxisLabel, yAxisLabel }: LineChartProps) => {
	return (
		<Chart data={data} xAccessor="name" yAccessor="count">
			<Chart.elements.Title>{title}</Chart.elements.Title>
			{singleValue != null && (
				<Chart.elements.SubTitle>
					<Box paddingBlockEnd="space.200">
						<Heading as="span" size="xxlarge">
							{singleValue}
						</Heading>
					</Box>
				</Chart.elements.SubTitle>
			)}
			<Chart.elements.Menu hide />
			<Chart.elements.PointMarks hide />
			<Chart.elements.Layout showBorder={false} overflow="visible" />
			{xAxisLabel != null && <Chart.elements.AxisBottom label={xAxisLabel} />}
			{yAxisLabel != null && <Chart.elements.AxisLeft label={yAxisLabel} />}
		</Chart>
	);
};
